import Vue from "vue";
import { Module } from "vuex";

import { api } from "@/util/axios";
import { BlogCategory, Page } from "@/types";

export interface BlogCategoryState {
  categoryPage: Page<BlogCategory>;
}

const blogCategory: Module<BlogCategoryState, any> = {
  namespaced: true,
  state: () => ({
    categoryPage: {
      docs: [],
      limit: 0,
      page: 0,
      pages: 0,
      sort: "",
      total: 0,
    },
  }),
  getters: {
    getCategory: (state) => (categoryId: string) =>
      state.categoryPage.docs.find((c) => c._id === categoryId),
    categoryPage: (state) => state.categoryPage,
  },
  mutations: {
    ADD_CATEGORY: (state, _category) => {
      let idx = -1;
      state.categoryPage.docs.map((c, i) => {
        if (c._id === _category._id) idx = i;
      });
      if (idx === -1) state.categoryPage.docs.push(_category);
      else Vue.set(state.categoryPage.docs, idx, _category);
    },
    SET_CATEGORY_PAGE: (state, list) => {
      state.categoryPage = list;
    },
    REMOVE_CATEGORY(state, category) {
      const idx = -1;
      //   state.categoryPage.docs.map((c, i) => {
      //     if (c._id === category._id) idx = i;
      //   });
      //   if (idx > -1) state.categoryPage.docs.splice(idx, 1);
    },
  },
  actions: {
    fetchCategory(context, params: { businessId: string; categoryId: string }) {
      api
        .get(
          `/v1/blog-category?categoryId=${params.categoryId}&businessId=${params.businessId}`
        )
        .then((response) => {
          context.commit("ADD_CATEGORY", response.data.category);
        })
        .catch((error) => {
          context.dispatch(
            "setToast",
            {
              title: "Request failed!",
              type: "error",
              text: error.response?.data?.error?.message,
            },
            { root: true }
          );
        });
    },

    fetchCategoryList(
      context,
      params: {
        businessId: string;
        page?: number;
        limit?: number;
        q?: string;
        sort?: string;
      }
    ) {
      const { businessId, page = 1, limit = 10, q, sort } = params;

      let queryParams = `?businessId=${businessId}&page=${page}&limit=${limit}&_status=active`;
      if (q) queryParams += `&q=${q}`;
      if (sort) queryParams += `&sort=${sort}`;

      api
        .get(`/v1/blog-category${queryParams}`)
        .then((response) => {
          console.log("Blog categories response:", response.data);
          context.commit("SET_CATEGORY_PAGE", response.data.categoryPage);
        })
        .catch((error) => {
          console.error("Error fetching blog categories:", error);
          context.dispatch(
            "setToast",
            {
              title: "Request failed!",
              type: "error",
              text:
                error.response?.data?.error?.message ||
                "Failed to load categories",
            },
            { root: true }
          );
        });
    },

    async createCategory(context, payload) {
      // Convert businessId to business field as required by the API
      const requestPayload = {
        ...payload,
        business: payload.business || payload.businessId,
      };
      if (requestPayload.businessId) {
        delete requestPayload.businessId;
      }

      return await api
        .post(`/v1/blog-category`, requestPayload)
        .then((response) => {
          context.commit("ADD_CATEGORY", response.data.category);
          context.dispatch(
            "setToast",
            {
              title: "Success",
              type: "success",
              text: "Category created",
            },
            { root: true }
          );
          return response.data.category;
        })
        .catch((error) => {
          context.dispatch(
            "setToast",
            {
              title: "Request failed!",
              type: "error",
              text: error.response?.data?.error?.message,
            },
            { root: true }
          );
          throw error;
        });
    },

    updateCategory(context, data: { id: string; category: BlogCategory }) {
      api
        .put(`/v1/blog-category/${data.id}`, data.category)
        .then((response) => {
          context.commit("ADD_CATEGORY", response.data.category);
          context.dispatch(
            "setToast",
            {
              title: "Success",
              type: "success",
              text: "Category updated",
            },
            { root: true }
          );
        })
        .catch((error) => {
          context.dispatch(
            "setToast",
            {
              title: "Request failed!",
              type: "error",
              text: error.response?.data?.error?.message,
            },
            { root: true }
          );
        });
    },

    deleteCategory(context, params: { categoryId: string }) {
      api
        .delete(`/v1/blog-category/${params.categoryId}`)
        .then((response) => {
          context.commit("REMOVE_CATEGORY", response.data.category);
          context.dispatch(
            "setToast",
            {
              title: "Success",
              type: "success",
              text: "Category deleted",
            },
            { root: true }
          );
        })
        .catch((error) => {
          console.log("Error deleting category:", error);
          context.dispatch(
            "setToast",
            {
              title: "Request failed!",
              type: "error",
              text: error.response?.data?.error?.message,
            },
            { root: true }
          );
        });
    },
  },
};

export default blogCategory;
